import { render, staticRenderFns } from "./ImagenesEntrada.vue?vue&type=template&id=86961e3a"
import script from "./ImagenesEntrada.vue?vue&type=script&lang=js"
export * from "./ImagenesEntrada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports